export default __webpack_public_path__ + "static/media/logo-sm.db452406.svg";